/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.dashboard.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

/**
 * Zweck: Beschreibt class AppDashboardService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppDashboardService {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient) {
  }

/**
 * Beschreibt Methode getConfig und ihren Rückgabevertrag.
 */
  getConfig(): Observable<any> {
    return this.http.get<any>(
      '/dashboard/get_config'
    );
  }

/**
 * Beschreibt Methode setConfig und ihren Rückgabevertrag.
 */
  setConfig(config): Observable<any> {
    return this.http.post<any>(
      '/dashboard/set_config',
      {
        config: config
      }
    );
  }

/**
 * Beschreibt Methode setDomainDefaultConfig und ihren Rückgabevertrag.
 */
  setDomainDefaultConfig(config): Observable<any> {
    return this.http.post<any>(
      '/admin/dashboard/set_domain_config',
      {
        config: config
      }
    );
  }
}
